//styles
import {
  FeaturesWrapper,
  FeaturedListWrapper,
  HeaderSection,
  Label,
  Title,
  Description,
} from './OfferList.styles';

//containers
import { ContentPill } from '@/components/ContentPill';
import { Container } from '@/components/Grid';

// Non-translatable per-item structure (icon, link URL) — merged at render time
// with the translatable title/description from `content.items`, keyed by slug.
const itemMeta = {
  loadsmart_platform: { icon: null, url: '/' },
  loadsmart_ai: { icon: null, url: '/ai/' },
  dock_gate_yard: {
    icon: null,
    url: 'https://opendock.com/?utm_source=loadsmart-website',
  },
  ai_native_tms: {
    icon: null,
    url: 'https://shipperguide.com/?utm_source=loadsmart-website',
  },
  freight_brokerage: { icon: null, url: '/shipper/' },
  managed_transportation: {
    icon: null,
    url: '/shipper/managed-transportation/',
  },
};

// `content.items` decides which offers show (the LATAM site lists only two) and
// `content.urls` can override an offer's link (e.g. LATAM pages, Opendock locale).
export default function OfferList({ content }) {
  const featuredListContent = Object.keys(itemMeta)
    .filter((slug) => content.items[slug])
    .map((slug) => ({
      icon: itemMeta[slug].icon,
      title: content.items[slug].title,
      description: content.items[slug].description,
      link: {
        url: content.urls?.[slug] ?? itemMeta[slug].url,
        label: content.linkLabel,
      },
    }));

  return (
    <FeaturesWrapper>
      <Container>
        <HeaderSection>
          {content.label && <Label>{content.label}</Label>}
          <Title>{content.title}</Title>
          <Description>{content.description}</Description>
        </HeaderSection>
        <FeaturedListWrapper $count={featuredListContent.length}>
          {featuredListContent.length > 0 &&
            featuredListContent.map((item, key) => {
              return (
                <ContentPill
                  key={`itemlist-` + key}
                  content={item}
                  className="green"
                />
              );
            })}
        </FeaturedListWrapper>
      </Container>
    </FeaturesWrapper>
  );
}

export { OfferList };
